import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axiosInstance from './api';

const LANGS = [
  ['en', 'English'],
  ['fr', 'Français'],
  ['es', 'Español'],
];

/**
 * Language switcher: changes the UI language instantly, caches it in localStorage,
 * and persists it to the user's profile (/api/account/locale) so it follows them
 * across devices. Best-effort on the API call — UI still switches if it fails.
 */
export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const change = async (lng) => {
    setOpen(false);
    if (lng === current) return;
    i18n.changeLanguage(lng);
    localStorage.setItem('appLocale', lng);
    try { await axiosInstance.post('/account/locale', { locale: lng }); } catch { /* best-effort */ }
  };

  const label = (LANGS.find(([c]) => c === current) || LANGS[0])[1];

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen((o) => !o)}
        title="Change language"
        style={{
          display: 'flex', alignItems: 'center', gap: 8, background: 'transparent',
          border: '1px solid rgba(255,255,255,0.12)', borderRadius: 8, cursor: 'pointer',
          color: '#cbd5e1', padding: compact ? '6px 8px' : '8px 12px', fontSize: 13, width: '100%',
        }}
      >
        <i className="fas fa-globe" />
        {!compact && <span style={{ flex: 1, textAlign: 'left' }}>{label}</span>}
        <i className={`fas fa-chevron-${open ? 'up' : 'down'}`} style={{ fontSize: 10, opacity: 0.7 }} />
      </button>
      {open && (
        <div style={{
          position: 'absolute', bottom: 'calc(100% + 6px)', left: 0, minWidth: 150,
          background: '#0f172a', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 8,
          padding: 4, zIndex: 60, boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
        }}>
          {LANGS.map(([code, name]) => (
            <button
              key={code}
              onClick={() => change(code)}
              style={{
                display: 'block', width: '100%', textAlign: 'left', background: 'transparent',
                border: 'none', cursor: 'pointer', padding: '8px 10px', borderRadius: 6, fontSize: 13,
                color: code === current ? '#60a5fa' : '#cbd5e1',
              }}
            >
              {name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
